import React, { Fragment } from 'react';

// local dependencies
import { SiteHeader } from 'ui/containers/SiteHeader';
import { SiteFooter } from 'ui/containers/SiteFooter';
import { Flyout } from 'ui/containers/Flyout';

/**
 * @type {function}
 * @desc A Higher-Order-Component to enhance functionality of `Component`
 * @param {object} Component - A React component
 * @example
 * import { withHeaderAndFooter, WithHeaderAndFooter } from 'ui/hoc/withHeaderAndFooter';
 * import { testView as TestView } from 'views/Test.view';
 *
 * // create a component
 * const ComponentWithHOC = WithHeaderAndFooter( TestView );
 * @return {class} - A standard React component
 */
const withHeaderAndFooter = ( Component ) => {
    class WithHeaderAndFooter extends React.Component {
        constructor( props ) {
            super( props );
        }

        render() {
            return (
				<Fragment>
                    {/* site header */}
					<SiteHeader { ...this.props } />

                    {/* flyout */}
                    <Flyout />

                    {/* component view */}
					<Component { ...this.props }/>
                    
                    {/* site header */}
					<SiteFooter { ...this.props }/>
				</Fragment>
            );
        }
    }

    // set display name
    WithHeaderAndFooter.displayName = 'WithHeaderAndFooter';

    // set default props
    WithHeaderAndFooter.defaultProps = {};

    // return class
    return WithHeaderAndFooter;
};

export { withHeaderAndFooter };
